import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import { Link } from "react-router-dom";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";


const availableIcons = [
    "material-symbols:checkbook-outline",
    "material-symbols:folder-match-outline",
    "material-symbols:image-search-outline-sharp",
    "material-symbols:av-timer",
    "material-symbols:security",
    "material-symbols:rocket-launch",
    "material-symbols:analytics",
    "material-symbols:auto-awesome"
];

const initialCardValues = {
    cardId: "00000000-0000-0000-0000-000000000000",
    iconClass: "material-symbols:checkbook-outline",
    title: "",
    description: "",
    buttonText: "READY?",
    buttonLink: "/register",
    buttonColor: "#17a2b8", // default btn-info hex code
    iconBgColor: "text-bg-secondary",
    order: 0
};

export default function CardSection() {
    const [cards, setCards] = useState([]);
    const [values, setValues] = useState(initialCardValues);
    const [errors, setErrors] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [originalData, setOriginalData] = useState(null);

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    };

    useEffect(() => {
        getCards();
    }, []);

    const getCards = () => {
        axios.get(config.APIACTIVATEURL + config.GETCARDS, headerconfig)
            .then(res => {
                if (res.data.data && res.data.data.length > 0) {
                    setCards(res.data.data);
                }
            })
            .catch(err => console.log(err));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };

    const handleIconChange = (icon) => {
        setValues({ ...values, iconClass: icon });
    };

    const handleColorChange = (e) => {
        setValues({ ...values, buttonColor: e.target.value });
    };

    const validate = () => {
        let temp = {};
        temp.title = values.title ? true : false;
        temp.description = values.description ? true : false;
        setErrors(temp);
        return Object.values(temp).every(x => x === true);
    };

    const handleEdit = (card) => {
        setValues(card);
        setOriginalData(card);
        setIsEditMode(true);
        setIsAddingNew(false);
    };

    const handleAddNew = () => {
        setValues({
            ...initialCardValues,
            order: cards.length > 0 ? Math.max(...cards.map(c => c.order)) + 1 : 0
        });
        setIsAddingNew(true);
        setIsEditMode(true);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            const payload = {
                ...values,
                updatedDate: new Date().toISOString()
            };

            const apiCall = isAddingNew
                ? axios.post(config.APIACTIVATEURL + config.CREATECARD, payload, headerconfig)
                : axios.put(`${config.APIACTIVATEURL}${config.UPDATECARD}/${values.cardId}`, payload, headerconfig);

            apiCall
                .then(res => {
                    if (res.data.statusCode === 201) {
                        handleSuccess(isAddingNew ? "Card Created" : "Card Updated");
                        getCards();  // ✅ this re-fetches and updates the card list
                        resetForm();
                    }
                     else {
                        handleError(res.data.message);
                    }
                })
                .catch(err => {
                    console.error(err);
                    handleError(isAddingNew ? "Creation failed" : "Update failed");
                });
        }
    };

    const resetForm = () => {
        setValues(initialCardValues);
        setIsEditMode(false);
        setIsAddingNew(false);
        setOriginalData(null);
    };
    const onDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this card?')) {
            axios.delete(`${config.APIACTIVATEURL}${config.DELETECARD}/${id}`, headerconfig)
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        getCards(); // Refresh cards
                    } else {
                        handleError(response.data.message);
                    }
                })
                .catch((error) => {
                    console.error("Delete error:", error);
                    handleError("Failed to delete the card.");
                });
        }
    };


    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " is-invalid" : "";

    return (
           <div id="layout-wrapper">
                <Header />
                <SideBar />
                <div className="vertical-overlay" />
            
                
                <div className="main-content">
                    <div className="page-content"></div>
        <div className="container-fluid">
            <div className="layout-wrapper mb-5">
                <div className="container">
                    <div className="row g-4 mt-1">
                        {cards.length > 0 ? (
                            cards.sort((a, b) => a.order - b.order).map((card) => (
                                <div className="col-md-3 col-sm-6" key={card.cardId} style={{ minHeight: "200px" }}>
                                    <div className="card text-center border shadow-none">
                                        <div className="card-body py-4 px-4">
                                            <div className={`d-flex align-items-center justify-content-center round-48 rounded ${card.iconBgColor || 'text-bg-secondary'} flex-shrink-0 mb-3 mx-auto`}>
                                                <iconify-icon icon={card.iconClass} className="fs-7 text-white" />
                                            </div>
                                            <h5>{card.title}</h5>
                                            <p className="text-muted pb-3">{card.description}</p>
                                            <Link to={card.buttonLink} className="btn" style={{ backgroundColor: card.buttonColor, color: 'white' }}>
                                                {card.buttonText}
                                            </Link>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn-sm btn-outline-primary mt-2 me-2"
                                        onClick={() => handleEdit(card)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-danger mt-2"
                                        onClick={() => onDelete(card.cardId)}
                                    >
                                        Delete
                                    </button>

                                </div>
                            ))
                        ) : (
                            <div className="col-12 text-center py-5">
                                <p>No cards found. Add your first card!</p>
                            </div>
                        )}
                    </div>
                    <div className="text-end mt-3">
                        <button className="btn btn-success" onClick={handleAddNew}>
                            + Add New Card
                        </button>
                    </div>
                </div>
            </div>

            {isEditMode && (
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">
                                    {isAddingNew ? "Add New Card" : "Edit Card"}
                                </h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Title</label>
                                            <input
                                                type="text"
                                                name="title"
                                                value={values.title}
                                                onChange={handleInputChange}
                                                className={`form-control${applyErrorClass("title")}`}
                                            />
                                            {errors.title === false && (
                                                <div className="invalid-feedback">Title is required</div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Description</label>
                                            <textarea
                                                name="description"
                                                value={values.description}
                                                onChange={handleInputChange}
                                                className={`form-control${applyErrorClass("description")}`}
                                                rows={2}
                                            />
                                            {errors.description === false && (
                                                <div className="invalid-feedback">Description is required</div>
                                            )}
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Button Text</label>
                                            <input
                                                type="text"
                                                name="buttonText"
                                                value={values.buttonText}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Button Link</label>
                                            <input
                                                type="text"
                                                name="buttonLink"
                                                value={values.buttonLink}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Button Color</label>
                                            <input
                                                type="color"
                                                name="buttonColor"
                                                value={values.buttonColor}
                                                onChange={handleColorChange}
                                                className="form-control form-control-color"
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Select Icon</label>
                                            <div className="d-flex flex-wrap gap-2">
                                                {availableIcons.map(icon => (
                                                    <button
                                                        key={icon}
                                                        type="button"
                                                        className={`btn btn-sm ${values.iconClass === icon ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                        onClick={() => handleIconChange(icon)}
                                                        title={icon}
                                                    >
                                                        <iconify-icon icon={icon} />
                                                    </button>
                                                ))}
                                            </div>
                                            <div className="mt-2">
                                                Selected Icon: <iconify-icon icon={values.iconClass} /> {values.iconClass}
                                            </div>
                                        </div>

                                        <div className="col-12 text-end">
                                            <button type="submit" className="btn btn-primary me-2">Save</button>
                                            <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancel</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
        </div>
    );
}
